import React from "react";
import "./index.scss";
import { BASE_URL } from "../../../utils/constant";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material";

const ProPreLoginLayout = ({ heading, content, children }) => {
  const theme = useTheme();

  return (
    <div className="prelogin-layout">
      <div className="prelogin-layout_container">
        <div className="prelogin-layout_logo">
          <img src={theme.palette.propreloginlayout.logo} alt="logo" />
        </div>
        <div className="prelogin-layout_card">
          <div className="prelogin-layout_card_heading">
            <h1>{heading ?? "LogIn"}</h1>
            {content && <p>{content}</p>}
          </div>
          {children}
        </div>
      </div>
      <div className="preLogin-footer">
        <a className="preLogin-footer-link" href={`${BASE_URL}/privacy-policy/`}>
          Privacy Policy
        </a>
        <a className="preLogin-footer-link" href={`${BASE_URL}/terms-conditions/`}>
          Terms of Service
        </a>
        <a className="preLogin-footer-link" href={`${BASE_URL}/cookie-policy/`}>
          Cookie Policy
        </a>
        <a className="preLogin-footer-link" href={`${BASE_URL}/eula/`}>
          EULA
        </a>
      </div>
    </div>
  );
};

ProPreLoginLayout.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.node
};

export default ProPreLoginLayout;
